import axios from 'axios';
import config from '../constants/config';

/**
 * Helper function for Axios POST requests with optional custom headers
 * @param {string} endpoint - API endpoint (without base URL)
 * @param {object} data - The data to send in the request body
 * @param {function} callback - Callback function that receives the response data
 * @param {object} customHeaders - Optional additional headers to include in the request
 */
const axiosPost = (endpoint, customHeaders = {}, data, callback) => {
  // Default headers
  const headers = {
    'api': config.api.key,
    ...customHeaders
  };

  axios.post(
    `${config.api.url}${endpoint}`, 
    data,
    {
      crossdomain: true,
      headers
    }
  )
  .then((response) => {
    callback(response.data);
  })
  .catch((error) => {
    console.error('Request error:', error);
  });
};

export default axiosPost;